var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 129,
    viewBox: "0 0 273 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M273 0V129H0V33.1412C32.6663 33.1412 43.4691 77.7233 59.1227 77.827C71.9408 77.9099 75.3855 56.9142 92.3513 56.9142C114.754 56.9142 114.473 92.1902 126.4 92.7291C138.328 93.2887 138.586 31.8977 170.549 31.8977C202.489 31.8977 197.216 72.0651 218.095 72.0651C238.975 72.0651 251.863 0 273 0Z",
    fill: "url(#paint0_linear_2010_1345)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2010_1345",
    x1: 136.506,
    y1: 131.315,
    x2: 136.506,
    y2: 1.63653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E31C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0813,
    stopColor: "#E3E527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5036,
    stopColor: "#EFEC5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#F7F079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAF285"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitor);
export default __webpack_public_path__ + "static/media/visitor.6de9974f011654b8be95cc6100627db9.svg";
export { ForwardRef as ReactComponent };